import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {BreadCrumbs} from "../../../components/open/pages";
import {GradeToString} from "../students/list";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {
    CheckIcon,
    ThinAddIcon,
    ThinCallIcon,
    ThinEditIcon,
    ThinTrashIcon
} from "../../../components/icons/material-icons";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {AdminsAddEditConsultNoteModal} from "./add-edit-note";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {RemoveModal} from "../../../components/template/remove-modal";

interface consultProfileAnswer {
    question: string,
    answer: string,
    type: string,
}

interface consultNote {
    id: number,
    text: string,
    createdAt: string,
}

export const AdminsConsultProfileViewScreen = () => {
    const {studentId} = useParams();
    const [data, setData] = useState({
        loaded: false,
        name: '',
        grade: 1,
        class: '',
        birthDate: '2000-01-01',
        fatherName: '',
        fatherCert: '',
        fatherJob: '',
        fatherTell: '',
        motherName: '',
        motherCert: '',
        motherJob: '',
        motherTell: '',
        livesWith: 'both',
        completedAt: '2000-01-01 00:00:00',
        answers: [] as consultProfileAnswer[],
    });
    const [notes, setNotes] = useState<consultNote[]>([]);
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/consult/profiles/view',
            {
                id: studentId?.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string,
                name: string,
                grade: number,
                class: string,
                birthDate: string,
                fatherName: string,
                fatherCert: string,
                fatherJob: string,
                fatherTell: string,
                motherName: string,
                motherCert: string,
                motherJob: string,
                motherTell: string,
                livesWith: string,
                completedAt: string,
                answers: consultProfileAnswer[] | null,
                notes: consultNote[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setData({
                    loaded: true,
                    answers: d.answers === null ? [] : d.answers,
                    name: d.name,
                    grade: d.grade,
                    class: d.class,
                    birthDate: d.birthDate,
                    fatherName: d.fatherName,
                    fatherCert: d.fatherCert,
                    fatherJob: d.fatherJob,
                    fatherTell: d.fatherTell,
                    motherName: d.motherName,
                    motherCert: d.motherCert,
                    motherJob: d.motherJob,
                    motherTell: d.motherTell,
                    livesWith: d.livesWith,
                    completedAt: d.completedAt,
                });
                document.title = d.name + " | مشاوره | اتوماسیون";
                setNotes(d.notes === null ? [] : d.notes);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        fetchData();
    }, []);
    const [addEditNote, setAddEditNote] = useState({
        show: false,
        edit: false,
        id: 0,
        note: '',
    });
    const [removeNote, setRemoveNote] = useState({
        show: false,
        id: 0,
        title: '',
    });
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'مشاوره', url: '/admins/consult'},
                {title: 'فرم‌های اطلاعات', url: '/admins/consult/profiles'},
                {title: data.loaded ? data.name : '...', url: `/admins/consult/profiles/view/${studentId}`},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="student-profile">
                                    <i style={{backgroundImage: 'url(https://techara-images.ir/u/default.png)'}}/>
                                    <b>{data.name}</b>
                                    <span>{GradeToString(data.grade)}</span>
                                    <strong>{data.class === '' ? 'بدون کلاس' : data.class}</strong>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="screen-card">
                                    <div className="screen-card-header">
                                        <b>مشخصات دانش‌آموز</b>
                                    </div>
                                    <div className="student-info">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <span>نام و نام‌خانوادگی:</span>
                                                <b>{data.name}</b>
                                                <span>پایه تحصیلی:</span>
                                                <b>{GradeToString(data.grade)}</b>
                                                <span>تاریخ تولد:</span>
                                                <b>{StringDigitsConvertToPersian(GregorianToPersian(data.birthDate).replaceAll('-', '/'))}</b>
                                                <span>نام پدر:</span>
                                                <b>{data.fatherName}</b>
                                                <span>مدرک تحصیلی پدر:</span>
                                                <b>{data.fatherCert}</b>
                                                <span>زندگی با:</span>
                                                <b>{data.livesWith === 'father' ? 'پدر' : (data.livesWith === 'mother' ? 'مادر' : 'هر دو والد')}</b>
                                            </div>
                                            <div className="col-lg-6">
                                                <span>تلفن پدر:</span>
                                                <b>
                                                    {StringDigitsConvertToPersian(data.fatherTell.replaceAll('+98', '0'))}
                                                    <a href={`tel:${data.fatherTell}`}
                                                       className="open-tooltip">
                                                        <ThinCallIcon/>
                                                        <i>تماس تلفنی</i>
                                                    </a>
                                                </b>
                                                <span>شغل پدر:</span>
                                                <b>{data.fatherJob}</b>
                                                <span>نام مادر:</span>
                                                <b>{data.motherName}</b>
                                                <span>تلفن مادر:</span>
                                                <b>
                                                    {StringDigitsConvertToPersian(data.motherTell.replaceAll('+98', '0'))}
                                                    <a href={`tel:${data.motherTell}`}
                                                       className="open-tooltip">
                                                        <ThinCallIcon/>
                                                        <i>تماس تلفنی</i>
                                                    </a>
                                                </b>
                                                <span>مدرک مادر:</span>
                                                <b>{data.motherCert}</b>
                                                <span>شغل مادر:</span>
                                                <b>{data.motherJob}</b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="screen-card">
                                    <div className="screen-card-header">
                                        <b>یادداشت‌های مشاور</b>
                                        <button onClick={() => setAddEditNote({
                                            show: true,
                                            edit: false,
                                            id: 0,
                                            note: '',
                                        })}>
                                            <ThinAddIcon/>
                                            <span>یادداشت جدید</span>
                                        </button>
                                    </div>
                                    {
                                        notes.length === 0 ?
                                            <div className="staff--not-found">
                                                <b>یادداشتی یافت نشد</b>
                                                <p>مشاور مدرسه هنوز یادداشتی برای این دانش‌آموز ثبت نکرده است.</p>
                                            </div> :
                                            <table className="table open-table table-hover table-striped table-bordered">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>یادداشت</th>
                                                    <th>تاریخ</th>
                                                    <th>امکانات</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    notes.map((d, i) =>
                                                        <tr key={"MxsHs92" + i}>
                                                            <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                            <td>{d.text}</td>
                                                            <td>{StringDigitsConvertToPersian(d.createdAt.split(' ')[1] + " " + GregorianToPersian(d.createdAt.split(' ')[0]).replaceAll('-', '/'))}</td>
                                                            <td>
                                                                <div className="d-inline-flex" style={{gap: 5}}>
                                                                    <button className="open-tooltip" onClick={()=>setAddEditNote({
                                                                        note: d.text,
                                                                        edit: true,
                                                                        show: true,
                                                                        id: d.id,
                                                                    })}>
                                                                        <ThinEditIcon/>
                                                                        <i>ویرایش</i>
                                                                    </button>
                                                                    <button className="open-tooltip" onClick={()=>setRemoveNote({
                                                                        id: d.id,
                                                                        show: true,
                                                                        title: d.text,
                                                                    })}>
                                                                        <ThinTrashIcon/>
                                                                        <i>حذف</i>
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                                </tbody>
                                            </table>
                                    }
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="screen-card">
                                    <div className="screen-card-header">
                                        <b>پاسخ‌های داده شده</b>
                                    </div>
                                    {
                                        data.answers.map((d, i) =>
                                            <div key={"JfXdsDs" + i} className={"students-consult-form-item"}>
                                                <p>{d.question}</p>
                                                {
                                                    d.type === 'radio' || d.type === 'check' ?
                                                        <button className={"techaran-checkbox active"}>
                                                            <i><CheckIcon/></i>
                                                            <span>{d.answer}</span>
                                                        </button>
                                                        :
                                                        <input type="text"
                                                               className={"form-control"}
                                                               value={d.answer}
                                                        />
                                                }
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
            <AdminsAddEditConsultNoteModal
                active={addEditNote.show}
                closeHandler={() => setAddEditNote(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                edit={addEditNote.edit}
                studentId={studentId as string}
                noteId={addEditNote.id}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                }}
                note={addEditNote.note}
            />
            <RemoveModal
                active={removeNote.show}
                closeHandler={() => setRemoveNote(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف یادداشت"}
                desc={"آیا مطمئن هستید که می‌خواهید یادداشت انتخاب شده را حذف نمایید؟"}
                onRemove={() => {
                    const x = {...removeNote};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/consult/notes/remove',
                        {
                            note: x.id,
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'یادداشت حذف گردید.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchData();
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
        </>
    );
};